export default {
  'memberCard.title': 'บัตรสมาชิก',
  'memberCard.exchangePoint': 'แลกแต้ม',
  'memberCard.exchange': 'แลกสิทธิ์',
  'memberCard.transfer': 'โอนคะแนน',
  'memberCard.stamp': 'สะสมตรา',
  'memberCard.message.invalid': 'ฟังก์ชันบัตรสมาชิกยังไม่เปิดใช้งาน กรุณารอการอัปเดต.',
  'memberCard.setting_invoice_carrier': 'ตั้งค่าผู้ให้บริการใบแจ้งหนี้',
  'memberCard.show_invoice_carrier': 'แสดงผู้ให้บริการใบแจ้งหนี้',
  'memberCard.hide_invoice_carrier': 'ซ่อนผู้ให้บริการใบแจ้งหนี้',
  'memberCard.total_consumption': 'ยอดใช้จ่ายสะสมทั้งหมด',
  'memberCard.near_expired_point': 'คะแนนที่ใกล้หมดอายุ',
  'memberCard.point': 'คะแนนสะสม',
  'memberCard.expire': 'หมดอายุ',
  'memberCard.member_period': 'ระยะเวลาสมาชิก',
  'memberCard.no_limit': 'ไม่จำกัดอายุการใช้งาน',
  'memberCard.to': 'ถึง',
  'memberCard.need_consumption': 'กรุณาใช้จ่ายเพิ่มเติม',
  'memberCard.point_rights': 'สิทธิ์การสะสมคะแนน',
  'memberCard.point_records': 'บันทึกการสะสมคะแนน',
  'memberCard.choose_notice': 'กรุณาเลือกวิธีการใช้งาน',
  'memberCard.add_consumption_record': 'เพิ่มบันทึกการใช้จ่าย',
  'memberCard.point.collect': 'สะสมคะแนน',
  'memberCard.add_trade_record': 'เพิ่มบันบันทึกการทำรายการ',
  'memberCard.become_brand_friend': 'เป็นเพื่อนกับแบรนด์',
  'memberCard.invalid': 'ยังไม่เปิดใช้งาน',
  'memberCard.not_open': 'ยังไม่เปิดให้บริการ',
  'memberCard.transfer_point': 'โอนคะแนน',
  'memberCard.transfer_to_friend': 'โอนคะแนนให้เพื่อน',
  'memberCard.transfer_success': 'โอนคะแนนสำเร็จแล้ว!',
  'memberCard.error.can_not_transfer_to_self': 'ไม่สามารถทำการโอนคะแนนให้ตัวเองได้',
  'memberCard.error.friend_not_member':
    'ไม่สามารถโอนคะแนนได้ เนื่องจากเพื่อนของคุณยังไม่ได้เป็นสมาชิกของแบรนด์ กรุณาเชิญให้เพื่อนลงทะเบียนเพื่อเป็นสมาชิก',
  'memberCard.notice.enter_friend_phone': 'กรุณาระบุหมายเลขโทรศัพท์ของเพื่อน',
  'memberCard.notice.friend_log_in': 'เพื่อนของคุณจะสามารถดูคะแนนได้เมื่อเข้าสู่ระบบ',
  'memberCard.notice.will_share': 'คุณต้องการโอนคะแนนให้กับ',
  'memberCard.notice.point_to': 'คะแนนจะถูกโอนไปที่',
  'memberCard.handle_time': 'เวลาในการดำเนินการ',
  'memberCard.error.member_point.not_match':
    'การใช้จ่ายครั้งนี้ยังไม่ผ่านเกณฑ์การสะสมคะแนนสมาชิก คะแนนจึงไม่ถูกสะสม; แต่การใช้จ่ายนี้ได้ถูกบันทึกในยอดใช้จ่ายสะสมของคุณแล้ว',
  'memberCard.error.MEMBER_CARD_EXTERNAL_TOKEN_FAILED':
    'การยืนยันไม่สำเร็จ กรุณาสแกนใหม่หรือลองอีกครั้งภายหลัง',
  'memberCard.error.MEMBER_CARD_EXTERNAL_BRAND_CODE_MISMATCH':
    'ข้อมูลแบรนด์ไม่ตรงกัน กรุณาตรวจสอบแล้วลองอีกครั้ง',
  'memberCard.error.MEMBER_CARD_SYSTEM_ERROR':
    'ระบบไม่สามารถดำเนินการได้ในขณะนี้ กรุณาลองใหม่ภายหลัง',
  'memberCard.error.unknown': 'เพิ่มรายการใช้จ่ายไม่สำเร็จ กรุณาลองใหม่ภายหลัง',
  'memberCard.change_send_point': 'เปลี่ยนแปลงการส่งคะแนน',
  'memberCard.change_deduct_point': 'เปลี่ยนแปลงการหักคะแนน',
  'memberCard.current_accumulated_point': 'คะแนนสะสมจากรายการนี้',
  'memberCard.accumulate': 'ยอดการใช้จ่าย',
  'memberCard.accumulated_point': 'คะแนนสะสม',
  'memberCard.accumulated_member_point': 'คะแนนสะสมสำหรับสมาชิก',
  'memberCard.point_change_fail': 'ไม่สามารถเปลี่ยนแปลงคะแนน',
  'memberCard.trade_has_accumulated': 'รายการนี้ได้ถูกบันทึกในยอดใช้จ่ายสะสมของคุณแล้ว',
  'memberCard.consumption_record_add_fail': 'เพิ่มรายการใช้จ่ายไม่สำเร็จ',
  'memberCard.no_member_benefit': 'ขณะนี้ยังไม่มีสิทธิประโยชน์สำหรับสมาชิก',
  'memberCard.your_member_level': 'ระดับสมาชิกของคุณในขณะนี้',
  'memberCard.other_member_level': 'ระดับสมาชิกอื่นๆ',
  'memberCard.member_ship': 'สถานะสมาชิก',
  'memberCard.accumulated_consumption': 'ยอดใช้จ่ายที่สะสมภายในสถานะ',
  'memberCard.total_accumulated_consumption': 'ยอดใช้จ่ายสะสมทั้งหมด',
  'memberCard.price.level': 'ยอดใช้จ่ายสะสมภายในระดับ',
  'memberCard.price.membership': 'ยอดใช้จ่ายสะสมภายในสถานะสมาชิก',
  'memberCard.dollar': 'บาท',
} as Record<string, string>;
